<template>
  <v-container fluid class="scroll-y fullscreen" pa-0>
    <v-card
        class="mx-auto"
        flat
        :loading="loading"
        loader-height="10"
        tile
    >
        <v-toolbar
        color="#003a6f"
        dark
        flat
        >
            <!--<v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>-->
            <v-spacer></v-spacer>
            <v-dialog
              v-model="dialog"
              max-width="500px"
              scrollable
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  tile
                  small
                >
                  <v-icon dark>mdi-plus</v-icon>
                  Add New
                </v-btn>
              </template>
              <v-card flat color="#004889">
                <v-card-title class="accent">
                  <span class="title text-uppercase white--text">{{ formTitle }}</span>
                  <v-spacer></v-spacer>
                  <v-btn small color="red" tile @click="deleteItem(form.id)">
                    <v-icon
                    color="white"
                    >
                    mdi-delete
                  </v-icon>  
                </v-card-title>

                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                      <v-form ref="warrantyform">
                        <v-list flat color="#004889" class="py-0">
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="white--text font-weight-bold">Title</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Title" rules="required">
                                    <v-text-field
                                      v-model="form.title"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                    ></v-text-field>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                    <v-text-field
                                      v-model="form.city"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                    ></v-text-field>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list-item class="form-row">
                              <v-list-item-content class="label">
                                  <v-list-item-title class="white--text font-weight-bold">Date</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                  >
                                      <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                          v-model="computedDateFormatted"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          solo
                                          flat
                                          dark
                                      ></v-text-field>
                                      </template>
                                      <v-date-picker
                                      v-model="form.date"
                                      @input="menu = false"
                                      ></v-date-picker>
                                  </v-menu>
                              </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-form>
                    </ValidationObserver>
                  </v-card-text>
                  <v-card-actions class="accent">
                    <v-btn
                      large min-width="49%" color="white" text
                      @click="close"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      large min-width="49%" color="primary" tile
                      @click="save"
                      :loading="loading"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
              </v-card>
            </v-dialog>
        </v-toolbar>
    </v-card>
    <v-row class="fill-height">
        <v-col class="pt-0 pb-0">
            <v-sheet height="64">
                <v-toolbar flat color="white">
                <v-btn outlined class="mr-4" @click="setToday">
                    Today
                </v-btn>
                <v-btn fab text small @click="prev">
                    <v-icon small>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab text small @click="next">
                    <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <!--<div class="flex-grow-1"></div>
                <v-menu bottom right>
                    <template v-slot:activator="{ on }">
                    <v-btn outlined v-on="on">
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right>mdi-menu-down</v-icon>
                    </v-btn>
                    </template>
                    <v-list>
                    <v-list-item @click="type = 'day'">
                        <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                        <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                        <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 days</v-list-item-title>
                    </v-list-item>
                    </v-list>
                </v-menu>-->
                </v-toolbar>
            </v-sheet>

            <v-sheet>
                <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="events"
                :event-color="getEventColor"
                :event-margin-bottom="3"
                :now="today"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @change="updateRange"
                @mousedown:event="startDrag"
                @mousedown:time="startTime"
                @mousemove:time="mouseMove"
                @mouseup:time="endDrag"
                @mouseleave.native="cancelDrag"
                >
                  <template v-slot:event="{ event, timed }">
                    <div
                      class="v-event-draggable"
                      v-html="event.name"
                    ></div>
                    <div
                      v-if="timed"
                      class="v-event-drag-bottom"
                      @mousedown.stop="extendBottom(event)"
                    ></div>
                  </template>                
                </v-calendar>
            </v-sheet>
        </v-col>
    </v-row>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card color="red">
        <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions class="red darken-4">
          <v-spacer></v-spacer>
          <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import mixin from '../mixin/main.js'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
  mixins: [mixin],
  data: () => ({
    loading: false,
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: '#1976D2', // default event color
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    dialog: false,
    dialogDate: false,
    dialogDelete: false,
    apiUrl: '',
    form: {
      id: '',
      title: '',
      city: '',
      date: new Date().toISOString().substr(0, 10),
    },
    defaultItem: {
      id: '',
      title: '',
      city: '',
      date: new Date().toISOString().substr(0, 10),
    },
    editedIndex: -1,
    dragEvent: null,
    dragStart: null,
    createEvent: null,
    createStart: null,
    extendOriginal: null,
  }),
  created() {
    this.apiUrl = this.$route.meta.api
  },
  mounted () {
    this.getEvents()
  },
  computed: {
    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)
      switch (this.type) {
        case 'month':
        return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
        return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
        return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },
    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    },
    cheight() {
      return window.innerHeight - 128
    },
    computedDateFormatted () {
        return this.formatDate(this.form.date)
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  components: {
      ValidationProvider,
      ValidationObserver,
  },
  watch: {
      dialog (val) {
          val || this.close()
      },
      dialogDelete (val) {
          val || this.closeDelete()
      },
  },
  methods: {
    async getEvents () {
      this.loading = true
      axios.get(this.apiUrl)
      .then(response => {
          this.loading = false
          this.events = response.data
          this.$nextTick()
      })
    },
    async save () {
        if (this.editedIndex > -1) {
          let valid1 = await this.$refs.observer1.validate()

          if(valid1) {
              this.loading = true
              axios.post('crm/custom_calendar/update', this.form).then(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'green')
                  this.$store.commit('SET_SNACK', 'Successfully saved!')
                  this.getEvents()
                  this.close()
              }).catch(error => {
                  console.log(error)
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  if(error.response.data.error) {
                      this.$store.commit('SET_SNACK', error.response.data.error)
                  } else {
                      this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                  }
              })
          } else {
              this.$store.commit('SET_SNACKTYPE', 'red')
              this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
          }
        } else {
          let valid1 = await this.$refs.observer1.validate()

          if(valid1) {
              this.loading = true
              axios.post('crm/custom_calendar/add', this.form).then(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'green')
                  this.$store.commit('SET_SNACK', 'Successfully saved!')
                  this.getEvents()
                  this.close()
              }).catch(error => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  if(error.response.data.error) {
                      this.$store.commit('SET_SNACK', error.response.data.error)
                  } else {
                      this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                  }
              })
          } else {
              this.$store.commit('SET_SNACKTYPE', 'red')
              this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
          }
        }
    },
    setDialogDate( { date }) {
      this.dialogDate = true
      this.focus = date
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor () {
      return '#1976d2'
    },
    showEvent ({ nativeEvent, event }) {
      this.editedIndex = 1
      this.form.id = event.id
      this.form.title = event.title
      this.form.city = event.city
      this.form.date = event.start
      this.dialog = true

      nativeEvent.stopPropagation()
    },
    setToday () {
      this.focus = this.today
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    updateRange ({ start, end }) {
      this.start = start
      this.end = end
    },
    nth (d) {
      return d > 3 && d < 21
      ? 'th'
      : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    deleteItem (id) {
        this.editedIndex = id
        this.dialogDelete = true
    },

    deleteItemConfirm () {
        this.loading = true
        axios.delete('crm/custom_calendar/delete?id=' + this.editedIndex)
            .then(() => {
              this.close()
              this.closeDelete()
              this.getEvents()
              this.$emit('update-job')
              this.$nextTick()
        })
    },

    closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
    },
    
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    startDrag ({ event }) {
      if (event) {
        this.dragEvent = event
        this.dragTime = null
        this.extendOriginal = null
      }
    },
    startTime (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start

        this.dragTime = mouse - start
      } else {
        this.createStart = this.roundTime(mouse)
        this.createEvent = {
          name: `Event #${this.events.length}`,
          color: this.rndElement(this.colors),
          start: this.createStart,
          end: this.createStart,
          timed: true,
        }

        this.events.push(this.createEvent)
      }
    },
    extendBottom (event) {
      this.createEvent = event
      this.createStart = event.start
      this.extendOriginal = event.end
    },
    mouseMove (tms) {
      const mouse = this.toTime(tms)

      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start
        const end = this.dragEvent.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration

        this.dragEvent.start = newStart
        this.dragEvent.end = newEnd
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)

        this.createEvent.start = min
        this.createEvent.end = max
      }
    },
    endDrag () {
      this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },
    cancelDrag () {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        } else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
        }
      }

      this.createEvent = null
      this.createStart = null
      this.dragTime = null
      this.dragEvent = null
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
        ? time - time % roundDownTime
        : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
  }
}
</script>

<style lang="sass">
.v-calendar .v-event
    white-space: normal!important
    height: auto!important

    div 
      white-space: normal
      text-align: center
      padding: 6px!important
</style>